import React, { ReactElement, useLayoutEffect, useRef, useState } from 'react';

export const OneTimeMeasurer = ({
  contentToMeasure,
  onMeasured,
}: {
  contentToMeasure: ReactElement;
  onMeasured: (width: number) => void;
}) => {
  const [isMeasured, setIsMeasured] = useState(false);
  const contentRef = useRef<HTMLButtonElement>(null);

  useLayoutEffect(() => {
    if (contentRef.current && !isMeasured) {
      onMeasured(contentRef.current.offsetWidth);
      setIsMeasured(true);
    }
  }, [isMeasured, onMeasured]);

  if (isMeasured) {
    return null;
  }

  return React.cloneElement(contentToMeasure, {
    ref: contentRef,
    className: `${contentToMeasure.props.className || ''} invisible absolute`.trim(),
    tabIndex: -1,
    'aria-hidden': true,
  });
};
